import { render } from "./UserMessage.vue?vue&type=template&id=bbfab570&ts=true"
import script from "./UserMessage.ts?vue&type=script&lang=ts&external"
export * from "./UserMessage.ts?vue&type=script&lang=ts&external"

import "./UserMessage.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__